// 2022 Topps Star Wars Chrome Black — GENERATED by pipeline-publish (2026-05-25)
// =============================================================================
// Auto-generated from the set draft. Colors, sub-set types, ordering, and the
// SET_REGISTRY entry below are filled in. REVIEW before committing:
//   - Any placeholder color marker (a parallel name not in the standard color
//     map; the commit guard blocks until every one is resolved).
//   - Rule-7 base serial slots on numbered auto/sketch sub-sets (see in-array
//     notes; the warnings list above flags only sub-sets actually missing one).
//   - Sanity-check the auto-classified sub-set `type` and ordering.
//   - Any placeholder in the SET_REGISTRY entry below (only present if no DB
//     sets row exists for this slug, or fields are blank).
//   - A source/specimen pass on parallel names + print runs.
//   - node --check src/sets/2022-chrome-black.js if committing by hand, then commit + push.
//
// SET_REGISTRY entry (paste into src/setRegistry.js):
//   {
//     id: "2022-chrome-black",
//     name: "2022 Topps Star Wars Chrome Black",
//     shortName: "Chrome Black 2022",
//     year: 2022,
//     brand: "Topps",
//     category: 'Star Wars',
//     releaseDate: "2022",
//     totalCards: 240,
//     description: "Topps 2022 Topps Star Wars Chrome Black trading card set.",
//     color: "#4fc3f7",
//     accentColor: "#f0c040",
//     dataFile: "2022-chrome-black",
//   },
// =============================================================================

export const SETS = [
  {
    id: "base-cards",
    type: "base",
    title: "BASE CARDS",
    parallels: [
        { id: "refractors", name: "Refractors", print_run: 199, color: "#c8d8f0" },
        { id: "green-refractors", name: "Green Refractors", print_run: 99, color: "#00e676" },
        { id: "blue-refractors", name: "Blue Refractors", print_run: 75, color: "#2979ff" },
        { id: "gold-refractors", name: "Gold Refractors", print_run: 50, color: "#f0c040" },
        { id: "orange-refractors", name: "Orange Refractors", print_run: 25, color: "#ff9100" },
        { id: "magenta-refractors", name: "Magenta Refractors", print_run: 10, color: "#9aa7c0" },
        { id: "red-refractors", name: "Red Refractors", print_run: 5, color: "#ff1744" },
        { id: "superfractors", name: "Superfractors", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "1", name: "Darth Vader (Star Wars: A New Hope)" },
        { n: "2", name: "Obi-Wan Kenobi (Star Wars: The Phantom Menace)" },
        { n: "3", name: "Yoda (Star Wars: The Empire Strikes Back)" },
        { n: "4", name: "Han Solo (Star Wars: A New Hope)" },
        { n: "5", name: "Luke Skywalker (Star Wars: A New Hope)" },
        { n: "6", name: "Chewbacca (Star Wars: A New Hope)" },
        { n: "7", name: "R2-D2 (Star Wars: A New Hope)" },
        { n: "8", name: "Princess Leia Organa (Star Wars: A New Hope)" },
        { n: "9", name: "Boba Fett (Star Wars: Return of the Jedi)" },
        { n: "10", name: "Darth Maul (Star Wars: The Phantom Menace)" },
        { n: "11", name: "Ahsoka Tano (The Mandalorian)" },
        { n: "12", name: "The Mandalorian (The Mandalorian)" },
        { n: "13", name: "Emperor Palpatine (Star Wars: Revenge of the Sith)" },
        { n: "14", name: "C-3PO (Star Wars: A New Hope)" },
        { n: "15", name: "Lando Calrissian (Solo: A Star Wars Story)" },
        { n: "16", name: "Grogu (The Mandalorian)" },
        { n: "17", name: "Jabba The Hutt (Star Wars: The Phantom Menace)" },
        { n: "18", name: "Admiral Ackbar (Star Wars: The Force Awakens)" },
        { n: "19", name: "Count Dooku (Star Wars: Attack of the Clones)" },
        { n: "20", name: "Kylo Ren (Star Wars: The Force Awakens)" },
        { n: "21", name: "Rey (Star Wars: The Force Awakens)" },
        { n: "22", name: "BB-8 (Star Wars: The Force Awakens)" },
        { n: "23", name: "Poe Dameron (Star Wars: The Force Awakens)" },
        { n: "24", name: "Finn (Star Wars: The Force Awakens)" },
        { n: "25", name: "Greedo (Star Wars: A New Hope)" },
        { n: "26", name: "K-2SO (Rogue One: A Star Wars Story)" },
        { n: "27", name: "Captain Tarkin (Star Wars: The Clone Wars)" },
        { n: "28", name: "Mace Windu (Star Wars: Attack of the Clones)" },
        { n: "29", name: "Chirrut Îmwe (Rogue One: A Star Wars Story)" },
        { n: "30", name: "Bib Fortuna (Star Wars: The Phantom Menace)" },
        { n: "31", name: "Qui-Gon Jinn (Star Wars: The Phantom Menace)" },
        { n: "32", name: "General Grievous (Star Wars: Revenge of the Sith)" },
        { n: "33", name: "Wicket W. Warrick (Star Wars: Return of the Jedi)" },
        { n: "34", name: "Enfys Nest (Solo: A Star Wars Story)" },
        { n: "35", name: "Mon Mothma (Star Wars: Return of the Jedi)" },
        { n: "36", name: "Vice Admiral Holdo (Star Wars: The Last Jedi)" },
        { n: "37", name: "Wedge Antilles (Star Wars: Return of the Jedi)" },
        { n: "38", name: "Qi'ra (Solo: A Star Wars Story)" },
        { n: "39", name: "Jar Jar Binks (Star Wars: The Phantom Menace)" },
        { n: "40", name: "Sebulba (Star Wars: The Phantom Menace)" },
        { n: "41", name: "Padmé Amidala (Star Wars: The Phantom Menace)" },
        { n: "42", name: "Jango Fett (Star Wars: Attack of the Clones)" },
        { n: "43", name: "Hunter (Star Wars: The Bad Batch)" },
        { n: "44", name: "Wrecker (Star Wars: The Bad Batch)" },
        { n: "45", name: "Tech (Star Wars: The Bad Batch)" },
        { n: "46", name: "Crosshair (Star Wars: The Bad Batch)" },
        { n: "47", name: "Echo (Star Wars: The Bad Batch)" },
        { n: "48", name: "Omega (Star Wars: The Bad Batch)" },
        { n: "49", name: "Captain Phasma (Star Wars: The Force Awakens)" },
        { n: "50", name: "Grand Admiral Thrawn (Star Wars Rebels)" },
        { n: "51", name: "Asajj Ventress (Star Wars: The Clone Wars)" },
        { n: "52", name: "Moff Gideon (The Mandalorian)" },
        { n: "53", name: "Fennec Shand (The Mandalorian)" },
        { n: "54", name: "Koska Reeves (The Mandalorian)" },
        { n: "55", name: "Kuiil (The Mandalorian)" },
        { n: "56", name: "IG-11 (The Mandalorian)" },
        { n: "57", name: "Greef Karga (The Mandalorian)" },
        { n: "58", name: "Mayfeld (The Mandalorian)" },
        { n: "59", name: "Cobb Vanth (The Mandalorian)" },
        { n: "60", name: "Peli Motto (The Mandalorian)" },
        { n: "61", name: "Bo-Katan Kryze (The Mandalorian)" },
        { n: "62", name: "Axe Woves (The Mandalorian)" },
        { n: "63", name: "Ezra Bridger (Star Wars Rebels)" },
        { n: "64", name: "Sabine Wren (Star Wars Rebels)" },
        { n: "65", name: "Kanan Jarrus (Star Wars Rebels)" },
        { n: "66", name: "Captain Rex (Star Wars Rebels)" },
        { n: "67", name: "The Grand Inquisitor (Star Wars Rebels)" },
        { n: "68", name: "Zeb Orrelios (Star Wars Rebels)" },
        { n: "69", name: "Hera Syndulla (Star Wars Rebels)" },
        { n: "70", name: "Saw Gerrera (Rogue One: A Star Wars Story)" },
        { n: "71", name: "Jyn Erso (Rogue One: A Star Wars Story)" },
        { n: "72", name: "Cassian Andor (Rogue One: A Star Wars Story)" },
        { n: "73", name: "Galen Erso (Rogue One: A Star Wars Story)" },
        { n: "74", name: "Bodhi Rook (Rogue One: A Star Wars Story)" },
        { n: "75", name: "Director Krennic (Rogue One: A Star Wars Story)" },
        { n: "76", name: "Kit Fisto (Star Wars: Revenge of the Sith)" },
        { n: "77", name: "Boushh (Star Wars: Return of the Jedi)" },
        { n: "78", name: "Biggs Darklighter (Star Wars: A New Hope)" },
        { n: "79", name: "Zam Wesell (Star Wars: Attack of the Clones)" },
        { n: "80", name: "Bolo (Star Wars: The Bad Batch)" },
        { n: "81", name: "Commander Cody (Star Wars: Revenge of the Sith)" },
        { n: "82", name: "IG-88 (Star Wars: The Empire Strikes Back)" },
        { n: "83", name: "Anakin Skywalker (Star Wars: Revenge of the Sith)" },
        { n: "84", name: "Supreme Leader Snoke (Star Wars: The Last Jedi)" },
        { n: "85", name: "Rose Tico (Star Wars: The Last Jedi)" },
        { n: "86", name: "Beaumont Kin (Star Wars: The Rise of Skywalker)" },
        { n: "87", name: "Aurra Sing (Star Wars: The Phantom Menace)" },
        { n: "88", name: "Cad Bane (Star Wars: The Clone Wars)" },
        { n: "89", name: "Nala Se (Star Wars: The Bad Batch)" },
        { n: "90", name: "Lama Su (Star Wars: The Bad Batch)" },
        { n: "91", name: "Cut Lawquane (Star Wars: The Bad Batch)" },
        { n: "92", name: "Vice Admiral Rampart (Star Wars: The Bad Batch)" },
        { n: "93", name: "Quinlan Vos (Star Wars: The Clone Wars)" },
        { n: "94", name: "Lobot (Star Wars: The Empire Strikes Back)" },
        { n: "95", name: "Max Rebo (Star Wars: Return of the Jedi)" },
        { n: "96", name: "Salacious B. Crumb (Star Wars: Return of the Jedi)" },
        { n: "97", name: "Pao (Rogue One: A Star Wars Story)" },
        { n: "98", name: "Sidon Ithano (Star Wars: The Force Awakens)" },
        { n: "99", name: "Plo Koon (Star Wars: Revenge of the Sith)" },
        { n: "100", name: "Cid (Star Wars: The Bad Batch)" },
    ],
  },
  {
    id: "autograph-cards",
    type: "auto",
    title: "AUTOGRAPH CARDS",
    parallels: [
        // Rule 7 resolved: base autographs are unnumbered encased cards
        // (Cardboard Connection, 2026-07-29) — no base serial slot.
        { id: "green-refractors", name: "Green Refractors", print_run: 99, color: "#00e676" },
        { id: "gold-refractors", name: "Gold Refractors", print_run: 50, color: "#f0c040" },
        { id: "orange-refractors", name: "Orange Refractors", print_run: 25, color: "#ff9100" },
        { id: "red-refractors", name: "Red Refractors", print_run: 5, color: "#ff1744" },
        { id: "superfractors", name: "Superfractors", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "A-AB", name: "Anna Brewster" },
        { n: "A-AD", name: "Adam Driver" },
        { n: "A-AEH", name: "Alden Ehrenreich" },
        { n: "A-AK", name: "Andrew Kishino" },
        { n: "A-AS", name: "Andy Serkis" },
        { n: "A-ASE", name: "Amy Sedaris" },
        { n: "A-BD", name: "Ben Diskin (The Bad Batch)" },
        { n: "A-BDW", name: "Billy Dee Williams (The Rise of Skywalker)" },
        { n: "A-BED", name: "Ben Daniels" },
        { n: "A-BL", name: "Billie Lourd (The Rise of Skywalker)" },
        { n: "A-CF", name: "Carrie Fisher (The Last Jedi)" },
        { n: "A-CM", name: "Cameron Monaghan" },
        { n: "A-CS", name: "Christopher Sean" },
        { n: "A-CW", name: "Carl Weathers" },
        { n: "A-DBB", name: "Dee Bradley Baker (The Bad Batch)" },
        { n: "A-DBC", name: "Dee Bradley Baker" },
        { n: "A-DBE", name: "Dee Bradley Baker (The Bad Batch)" },
        { n: "A-DBH", name: "Dee Bradley Baker" },
        { n: "A-DBT", name: "Dee Bradley Baker" },
        { n: "A-DBW", name: "Dee Bradley Baker" },
        { n: "A-DC", name: "Dave Chapman" },
        { n: "A-DLI", name: "Diana Lee Inosanto" },
        { n: "A-DR", name: "Daisy Ridley" },
        { n: "A-EC", name: "Emilia Clarke" },
        { n: "A-EK", name: "Erin Kellyman" },
        { n: "A-EM", name: "Ewan McGregor" },
        { n: "A-ES", name: "Emily Swallow" },
        { n: "A-FJ", name: "Felicity Jones (Rogue One)" },
        { n: "A-FPJ", name: "Freddie Prinze Jr." },
        { n: "A-FW", name: "Forest Whitaker (Rogue One)" },
        { n: "A-GC", name: "Gwendoline Christie" },
        { n: "A-GE", name: "Giancarlo Esposito" },
        { n: "A-GG", name: "Greg Grunberg (The Rise of Skywalker)" },
        { n: "A-HC", name: "Hayden Christensen" },
        { n: "A-HF", name: "Harrison Ford" },
        { n: "A-HQ", name: "Hugh Quarshie" },
        { n: "A-IM", name: "Ian McDiarmid" },
        { n: "A-JB", name: "John Boyega (The Rise of Skywalker)" },
        { n: "A-JC", name: "Jim Cummings (Rebels)" },
        { n: "A-JD", name: "Julie Dolan" },
        { n: "A-JK", name: "Jaime King" },
        { n: "A-KMT", name: "Kelly Marie Tran" },
        { n: "A-KSH", name: "Kiran Shah" },
        { n: "A-MD", name: "Mark Dodson" },
        { n: "A-MIB", name: "Michonne Bourriague" },
        { n: "A-MNW", name: "Ming-Na Wen (The Mandalorian)" },
        { n: "A-MV", name: "Mercedes Varnado" },
        { n: "A-MW", name: "Matthew Wood" },
        { n: "A-NA", name: "Naomi Ackie" },
        { n: "A-NF", name: "Nika Futterman" },
        { n: "A-NN", name: "Nick Nolte" },
        { n: "A-NP", name: "Natalie Portman (Revenge of the Sith)" },
        { n: "A-PAR", name: "Philip Anthony-Rodriguez" },
        { n: "A-PK", name: "Paul Kasey (Rogue One)" },
        { n: "A-PL", name: "Phil LaMarr (The Bad Batch)" },
        { n: "A-PSL", name: "Paul Sun-Hyung Lee" },
        { n: "A-RAD", name: "Robin Atkin Downes (The Bad Batch)" },
        { n: "A-RD", name: "Rosario Dawson" },
        { n: "A-RZ", name: "Riz Ahmed" },
        { n: "A-SA", name: "Stephen Stanton (The Bad Batch)" },
        { n: "A-SB", name: "Steve Blum" },
        { n: "A-SL", name: "Scott Lawrence" },
        { n: "A-SLJ", name: "Samuel L. Jackson (Revenge of the Sith)" },
        { n: "A-TG", name: "Taylor Gray" },
        { n: "A-TR", name: "Tim Rose" },
        { n: "A-TS", name: "Tiya Sircar (Rebels)" },
        { n: "A-VM", name: "Vanessa Marshall (The Bad Batch)" },
        { n: "A-WD", name: "Warwick Davis (The Rise of Skywalker)" },
        { n: "A-WH", name: "Werner Herzog" },
    ],
  },
  {
    id: "autograph-b-design",
    type: "auto",
    title: "AUTOGRAPH B DESIGN",
    parallels: [
        // Rule 7 resolved: base autographs are unnumbered encased cards
        // (Cardboard Connection, 2026-07-29) — no base serial slot.
        { id: "gold-refractors", name: "Gold Refractors", print_run: 50, color: "#f0c040" },
        { id: "orange-refractors", name: "Orange Refractors", print_run: 25, color: "#ff9100" },
        { id: "red-refractors", name: "Red Refractors", print_run: 5, color: "#ff1744" },
        { id: "superfractors", name: "Superfractors", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "AB-AD", name: "Adam Driver" },
        { n: "AB-ADA", name: "Annabelle Davis" },
        { n: "AB-AL", name: "Amanda Lawrence" },
        { n: "AB-ASE", name: "Amy Sedaris" },
        { n: "AB-BD", name: "Ben Diskin (The Clone Wars)" },
        { n: "AB-BDW", name: "Billy Dee Williams (The Empire Strikes Back)" },
        { n: "AB-BH", name: "Brian Herring" },
        { n: "AB-BL", name: "Billie Lourd (The Last Jedi)" },
        { n: "AB-CF", name: "Carrie Fisher (The Empire Strikes Back)" },
        { n: "AB-CH", name: "Clint Howard" },
        { n: "AB-CS", name: "Christopher Sean" },
        { n: "AB-DBE", name: "Dee Bradley Baker (The Clone Wars)" },
        { n: "AB-DBR", name: "Dee Bradley Baker (The Clone Wars)" },
        { n: "AB-DR", name: "Daisy Ridley" },
        { n: "AB-EM", name: "Ewan McGregor" },
        { n: "AB-FJ", name: "Felicity Jones (Forces of Destiny)" },
        { n: "AB-FW", name: "Forest Whitaker (Rebels)" },
        { n: "AB-GC", name: "Gwendoline Christie" },
        { n: "AB-GG", name: "Greg Grunberg (The Force Awakens)" },
        { n: "AB-HC", name: "Hayden Christensen" },
        { n: "AB-HF", name: "Harrison Ford" },
        { n: "AB-IMC", name: "Ian McDiarmid" },
        { n: "AB-JB", name: "John Boyega (The Last Jedi)" },
        { n: "AB-JC", name: "Jim Cummings (The Clone Wars)" },
        { n: "AB-JI", name: "Jason Isaacs" },
        { n: "AB-KS", name: "Kiran Shah" },
        { n: "AB-KY", name: "Keone Young" },
        { n: "AB-LBR", name: "Lynn Robertson Bruce" },
        { n: "AB-LM", name: "Lars Mikkelsen" },
        { n: "AB-MBJ", name: "Mark Boone Jr." },
        { n: "AB-MNW", name: "Ming-Na Wen (The Bad Batch)" },
        { n: "AB-MR", name: "Misty Rosas" },
        { n: "AB-MU", name: "Megan Udall" },
        { n: "AB-MW", name: "Matthew Wood (The Rise of Skywalker)" },
        { n: "AB-NF", name: "Nika Futterman" },
        { n: "AB-NP", name: "Natalie Portman (Attack of the Clones)" },
        { n: "AB-PK", name: "Paul Kasey (The Rise of Skywalker)" },
        { n: "AB-PL", name: "Phil LaMarr (Rebels)" },
        { n: "AB-RAD", name: "Robin Atkin Downes (Rebels)" },
        { n: "AB-RB", name: "Ralph Brown" },
        { n: "AB-SLJ", name: "Samuel L. Jackson (The Phantom Menace)" },
        { n: "AB-SS", name: "Stephen Stanton (Resistance)" },
        { n: "AB-SW", name: "Sam Witwer (Solo: A Star Wars Story)" },
        { n: "AB-TS", name: "Tiya Sircar (Forces of Destiny)" },
        { n: "AB-WD", name: "Warwick Davis (Solo: A Star Wars Story)" },
    ],
  },
  {
    id: "dark-side-autographs",
    type: "auto",
    title: "DARK SIDE AUTOGRAPHS",
    parallels: [
        // Rule 7 resolved: base autographs are unnumbered encased cards
        // (Cardboard Connection, 2026-07-29) — no base serial slot.
        { id: "red-refractors", name: "Red Refractors", print_run: 5, color: "#ff1744" },
        { id: "superfractors", name: "Superfractors", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "DS-AB", name: "Anna Brewster" },
        { n: "DS-AD", name: "Adam Driver" },
        { n: "DS-AS", name: "Andy Serkis" },
        { n: "DS-DLI", name: "Diana Lee Inosanto" },
        { n: "DS-DR", name: "Daisy Ridley" },
        { n: "DS-GE", name: "Giancarlo Esposito" },
        { n: "DS-HC", name: "Hayden Christensen" },
        { n: "DS-IMC", name: "Ian McDiarmid" },
        { n: "DS-JI", name: "Jason Isaacs" },
        { n: "DS-PAR", name: "Philip Anthony-Rodriguez" },
        { n: "DS-PB", name: "Paul Bettany" },
        { n: "DS-RB", name: "Richard Brake" },
        { n: "DS-REG", name: "Richard E. Grant" },
        { n: "DS-SMG", name: "Sarah Michelle Gellar" },
        { n: "DS-SS", name: "Stephen Stanton" },
    ],
  },
  {
    id: "galactic-black-autographs",
    type: "auto",
    title: "GALACTIC BLACK AUTOGRAPHS",
    parallels: [
        // Rule 7 resolved: base autographs are unnumbered encased cards
        // (Cardboard Connection, 2026-07-29) — no base serial slot.
        { id: "red-refractors", name: "Red Refractors", print_run: 5, color: "#ff1744" },
        { id: "superfractors", name: "Superfractors", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "GB-AD", name: "Adam Driver" },
        { n: "GB-AE", name: "Alden Ehrenreich" },
        { n: "GB-CF", name: "Carrie Fisher" },
        { n: "GB-CW", name: "Carl Weathers" },
        { n: "GB-DR", name: "Daisy Ridley" },
        { n: "GB-EC", name: "Emilia Clarke" },
        { n: "GB-EM", name: "Ewan McGregor" },
        { n: "GB-HC", name: "Hayden Christensen" },
        { n: "GB-HF", name: "Harrison Ford" },
        { n: "GB-JB", name: "John Boyega" },
        { n: "GB-NP", name: "Natalie Portman" },
    ],
  },
];

export const ALL_CARD_KEYS = SETS.flatMap(set =>
  set.cards.map(card => `${set.id}__${card.n}`)
);

// Fallback exports used by Checklist.js for any sub-set with no inline `parallels`.
// Every sub-set above has its own inline array, so these stay empty.
export const PARALLELS = [];
export const AUTO_PARALLELS = [];
export const INSERT_PARALLELS = [];
